/**
 * gm-pdp-layout-lab — reorganiza a coluna de info do PDP desktop
 * (preço/parcelas/PIX/cashback/ATC/WhatsApp/bandeiras).
 *
 * PADRÃO DE PRODUÇÃO (variante T) já vem no Liquid/CSS — sem FOUC.
 * Este script:
 *  1. Sempre (desktop): fade do par Apple/WhatsApp ao rolar.
 *  2. Só com `?layoutlab=1`: painel pra comparar variantes (inclui o
 *     layout antigo como variante A). Sem o query, NÃO remonta o DOM.
 *
 * Variante escolhida DENTRO de uma sessão com o painel ativo continua
 * lembrada via localStorage — só a ativação do painel em si não persiste.
 */
(function () {
  const STORAGE_VARIANT = 'gmPdpLayoutLabVariant';
  const DESKTOP_MIN = 750;
  const DEFAULT_VARIANT_KEY = 'apple-whatsapp-par-duplo-fora-tela'; // T = Liquid default

  const params = new URLSearchParams(window.location.search);
  const panelEnabled = params.get('layoutlab') === '1';

  const VARIANTS = [
    {
      key: 'atual',
      label: 'A · Layout antigo (pré-T)',
      hint: 'Preço + parcelas/PIX perto da foto. WhatsApp, bandeiras e cashback no rodapé — layout original antes do padrão T.',
      summaryTail: ['price', 'offer'],
      buyFootOrder: ['whatsapp', 'payment', 'cashback'],
    },
    {
      key: 'pos-cta',
      label: 'B · Reforço pós-CTA',
      hint: 'Só o preço perto da foto. Parcelas/PIX + cashback logo abaixo do carrinho, antes do WhatsApp.',
      summaryTail: ['price'],
      buyFootOrder: ['offer', 'cashback', 'whatsapp', 'payment'],
    },
    {
      key: 'pre-cta',
      label: 'C · Tudo antes do CTA',
      hint: 'Preço, parcelas/PIX e cashback juntos perto da foto — o rodapé vira zona só de ação.',
      summaryTail: ['price', 'offer', 'cashback'],
      buyFootOrder: ['whatsapp', 'payment'],
    },
    {
      key: 'pill',
      label: 'D · Cashback em destaque',
      hint: 'Preço + parcelas perto da foto. Cashback vira um selo isolado logo após o carrinho.',
      summaryTail: ['price', 'offer'],
      buyFootOrder: ['cashback', 'whatsapp', 'payment'],
      pill: true,
    },
    {
      key: 'funil',
      label: 'E · Funil sequencial',
      hint: 'Só o preço perto da foto. WhatsApp, parcelas/PIX, bandeiras e cashback em sequência, um de cada vez.',
      summaryTail: ['price'],
      buyFootOrder: ['whatsapp', 'offer', 'payment', 'cashback'],
    },
    {
      key: 'fold-compacto',
      label: 'F · Cabe tudo na 1ª tela',
      hint: 'Parcelas/PIX + cashback logo abaixo do carrinho, ainda dentro da 1ª tela (foto encolhe se precisar). WhatsApp só depois do scroll.',
      summaryTail: ['price'],
      foldTail: ['offer', 'cashback'],
      buyFootOrder: ['whatsapp', 'payment'],
      compactFold: true,
    },
    {
      key: 'fold-compacto-natural',
      label: 'G · Cabe tudo, variações no tamanho natural',
      hint: 'Igual à F, mas as variações ocupam só a largura necessária (sem esticar até a largura da foto).',
      summaryTail: ['price'],
      foldTail: ['offer', 'cashback'],
      buyFootOrder: ['whatsapp', 'payment'],
      compactFold: true,
      naturalSwatchesWidth: true,
    },
    {
      key: 'dual-atc',
      label: 'H · Botão duplo ATC + WhatsApp',
      hint: 'WhatsApp vira um quadrado verde colado no carrinho. Hover troca os tamanhos: WhatsApp expande com a label, carrinho encolhe pro ícone.',
      summaryTail: ['price', 'offer'],
      buyFootOrder: ['payment', 'cashback'],
      dualAtc: true,
    },
    {
      key: 'fold-compacto-natural-dual-atc',
      label: 'I · G + botão duplo',
      hint: 'Mesmo layout da G (cabe tudo na 1ª tela, variações no tamanho natural), com o botão duplo ATC + WhatsApp no lugar do WhatsApp separado.',
      summaryTail: ['price'],
      foldTail: ['offer', 'cashback'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: true,
      dualAtc: true,
    },
    {
      key: 'fold-compacto-natural-dual-atc-parcelas-no-preco',
      label: 'J · Igual à I, parcelas junto ao preço',
      hint: 'Igual à I, mas parcelas/PIX voltam pra colados no preço original (perto da foto) — só o cashback fica com os botões.',
      summaryTail: ['price', 'offer'],
      foldTail: ['cashback'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: true,
      dualAtc: true,
    },
    {
      key: 'fold-compacto-natural-dual-atc-cashback-no-preco',
      label: 'K · Igual à I, cashback junto ao preço',
      hint: 'Igual à I, mas o cashback sobe pra perto da foto, junto do preço — parcelas/PIX continuam com os botões.',
      summaryTail: ['price', 'cashback'],
      foldTail: ['offer'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: true,
      dualAtc: true,
    },
    {
      key: 'fold-compacto-natural-dual-atc-tudo-no-preco',
      label: 'L · Preço, parcelas e cashback juntos perto da foto',
      hint: 'Preço, parcelas/PIX e cashback todos perto da foto. Só os botões (ATC duplo) + bandeiras ficam abaixo — a zona de ação fica mínima.',
      summaryTail: ['price', 'offer', 'cashback'],
      foldTail: [],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: true,
      dualAtc: true,
    },
    {
      key: 'fold-compacto-natural-dual-atc-preco-entre-thumbs-atc',
      label: 'M · Bloco de preços entre as variações e o ATC',
      hint: 'Foto e nome ficam sozinhos no topo. O bloco de preço + parcelas/PIX + cashback desce pra entre as miniaturas e o botão de adicionar ao carrinho.',
      summaryTail: [],
      beforeAtc: ['price', 'offer', 'cashback'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: true,
      dualAtc: true,
    },
    {
      key: 'fold-compacto-dual-atc-preco-entre-thumbs-atc-full-width',
      label: 'N · Igual à M, variações 100% da largura da foto',
      hint: 'Igual à M, mas as variações esticam até a largura da foto, com o fundo cinza preenchendo tudo.',
      summaryTail: [],
      beforeAtc: ['price', 'offer', 'cashback'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: false,
      dualAtc: true,
    },
    {
      key: 'padrao-whatsapp-verde-empilhado',
      label: 'O · Igual à N, WhatsApp verde empilhado',
      hint: 'Mesmo layout da N, mas sem botão duplo: WhatsApp vira um botão verde de largura cheia, logo abaixo do carrinho.',
      summaryTail: [],
      beforeAtc: ['price', 'offer', 'cashback'],
      foldTail: ['whatsapp'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: false,
      dualAtc: false,
      whatsappGreen: true,
    },
    {
      key: 'apple-quadrado-antes-atc',
      label: 'P · Apple Pay antes do ATC (balanceado)',
      hint: 'Igual à N, com um quadrado preto do Apple Pay ANTES do carrinho — um ícone de cada lado do ATC (Apple à esquerda, WhatsApp à direita).',
      summaryTail: [],
      beforeAtc: ['price', 'offer', 'cashback'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: false,
      dualAtc: true,
      appleSquare: 'before',
    },
    {
      key: 'apple-quadrado-depois-wa',
      label: 'Q · Apple Pay junto ao WhatsApp (2 à direita)',
      hint: 'Igual à N, com um quadrado preto do Apple Pay colado ao lado do quadrado do WhatsApp — os dois ícones à direita do ATC.',
      summaryTail: [],
      beforeAtc: ['price', 'offer', 'cashback'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: false,
      dualAtc: true,
      appleSquare: 'after',
    },
    {
      key: 'apple-linha-cheia-abaixo',
      label: 'R · Apple Pay em linha própria abaixo do ATC+WhatsApp',
      hint: 'Igual à N (ATC + WhatsApp em botão duplo), com um botão preto do Apple Pay de largura cheia numa 3ª linha, abaixo dos dois.',
      summaryTail: [],
      beforeAtc: ['price', 'offer', 'cashback'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: false,
      dualAtc: true,
      appleFullRow: true,
    },
    {
      key: 'apple-whatsapp-par-duplo',
      label: 'S · ATC sozinho + par duplo Apple/WhatsApp abaixo',
      hint: 'ATC ocupa a linha inteira sozinho. Abaixo, Apple Pay e WhatsApp dividem uma 2ª linha com a mesma animação de hover.',
      summaryTail: [],
      beforeAtc: ['price', 'offer', 'cashback'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: false,
      dualAtc: false,
      appleWhatsappPair: 'fold',
    },
    {
      key: 'apple-whatsapp-par-duplo-fora-tela',
      label: 'T · Padrão (produção)',
      hint: 'Markup Liquid padrão: só ATC+wishlist na 1ª tela. Apple+WhatsApp (par dual) e bandeiras no rodapé com fade ao rolar.',
      summaryTail: [],
      beforeAtc: ['price', 'offer', 'cashback'],
      buyFootOrder: ['payment'],
      compactFold: true,
      naturalSwatchesWidth: false,
      dualAtc: false,
      appleWhatsappPair: 'buyfoot',
    },
  ];

  const DEFAULT_VARIANT = VARIANTS.find((v) => v.key === DEFAULT_VARIANT_KEY);

  const DUAL_ATC_CART_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
  const DUAL_ATC_WHATSAPP_ICON =
    '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2c-5.46 0-9.9 4.44-9.9 9.9 0 1.75.46 3.45 1.32 4.95L2 22l5.29-1.39a9.87 9.87 0 0 0 4.75 1.21h.01c5.46 0 9.9-4.44 9.9-9.9S17.5 2 12.04 2zm5.8 14.16c-.24.68-1.4 1.3-1.93 1.34-.5.04-1.03.24-3.46-.72-2.93-1.16-4.83-4.13-4.98-4.32-.14-.19-1.2-1.6-1.2-3.05s.75-2.16 1.02-2.46c.25-.28.55-.35.73-.35h.53c.17 0 .4-.02.62.48.24.55.8 1.9.87 2.04.07.14.11.3.02.48-.09.19-.14.3-.27.46-.14.16-.29.36-.41.48-.14.14-.28.28-.12.55.16.28.71 1.18 1.53 1.91 1.05.94 1.94 1.24 2.21 1.38.28.14.44.12.6-.07.17-.19.7-.82.89-1.1.19-.28.37-.23.62-.14.25.09 1.6.75 1.87.89.28.14.46.21.53.32.07.12.07.68-.17 1.36z"></path></svg>';
  const APPLE_PAY_ICON =
    '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M16.365 1.43c0 1.14-.493 2.27-1.177 3.08-.744.9-1.99 1.57-2.987 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.572-2.27 1.206-2.98.804-.94 2.142-1.64 3.248-1.68.03.13.05.28.05.43zm4.565 15.71c-.03.07-.463 1.58-1.518 3.12-.945 1.34-1.94 2.71-3.43 2.71-1.517 0-1.9-.88-3.63-.88-1.698 0-2.302.91-3.67.91-1.377 0-2.332-1.26-3.428-2.8-1.287-1.82-2.323-4.63-2.323-7.28 0-4.28 2.797-6.55 5.552-6.55 1.448 0 2.652.95 3.559.95.865 0 2.21-1.01 3.85-1.01.62 0 2.833.06 4.294 2.15-.111.07-2.563 1.5-2.563 4.6 0 3.71 3.26 5.02 3.307 5.03z"></path></svg>';

  function getDualLabelHTML(el) {
    if (!el) return '';
    const label = el.querySelector('.gm-dual-atc__label');
    return label ? label.innerHTML : el.innerHTML;
  }

  function init() {
    const hero = document.querySelector('.gm-pdp-hero[data-gm-pdp-scroll]');
    if (!hero) return;

    // Produção: layout T já está no Liquid — sem remount e sem fade.
    if (!panelEnabled) return;

    if (window.innerWidth < DESKTOP_MIN) return;

    const summary = hero.querySelector('.gm-pdp-hero__summary');
    const fold = hero.querySelector('.gm-pdp-hero__fold');
    const buyFoot = hero.querySelector('.gm-pdp-buy-foot');
    if (!summary || !fold || !buyFoot) return;

    const els = {
      price: hero.querySelector('.gm-pdp-price'),
      offer: hero.querySelector('.gm-pdp-atc-offer'),
      whatsapp: hero.querySelector('[data-gm-pdp-whatsapp]'),
      payment: hero.querySelector('.gm-payment-icons'),
      cashback: hero.querySelector('.gm-pdp-buy-foot__cashback:not(.gm-pdp-cashback--mobile-pin)'),
    };
    const swatchesEl = hero.querySelector('.gm-pdp-hero__swatches');
    const atcDockEl = hero.querySelector('.gm-pdp-atc-dock');
    const dockSlot = hero.querySelector('.gm-pdp-atc-dock__slot');
    const atcBtn = hero.querySelector('.gm-pdp-showcase__add-to-cart');
    const atcWrapper = atcBtn ? atcBtn.closest('.gm-atc--pdp') || atcBtn.parentElement : null;

    const originalAtcHTML = getDualLabelHTML(atcBtn);
    const originalWaHTML = els.whatsapp ? getDualLabelHTML(els.whatsapp) : '';
    const wishlistBtn = dockSlot ? dockSlot.querySelector('[data-gm-wishlist]') : null;

    const appleBtn = hero.querySelector('[data-gm-pdp-apple-pay]') || document.createElement('button');
    if (!appleBtn.hasAttribute('data-gm-pdp-apple-pay')) {
      appleBtn.type = 'button';
      appleBtn.setAttribute('aria-label', 'Apple Pay');
      appleBtn.setAttribute('data-gm-pdp-apple-pay', '');
    }
    const originalAppleHTML = appleBtn.innerHTML;
    const originalAppleClass = appleBtn.className;

    let appleWaRow = hero.querySelector('[data-gm-apple-wa-row]');

    function ensureWishlistDual() {
      if (!dockSlot || !atcWrapper || !atcBtn || !wishlistBtn) return;
      wishlistBtn.hidden = false;
      dockSlot.classList.add('gm-dual-atc');
      atcWrapper.classList.add('gm-dual-atc__atc');
      atcBtn.classList.add('gm-dual-atc__atc-btn');
      if (!atcBtn.querySelector('.gm-dual-atc__icon') || !atcBtn.querySelector('.gm-dual-atc__label')) {
        atcBtn.innerHTML =
          `<span class="gm-dual-atc__icon" aria-hidden="true">${DUAL_ATC_CART_ICON}</span>` +
          `<span class="gm-dual-atc__label">${originalAtcHTML}</span>`;
      }
    }

    function resetApple() {
      if (appleWaRow && appleWaRow.isConnected) {
        const parent = appleWaRow.parentElement;
        const next = appleWaRow.nextSibling;
        while (appleWaRow.firstChild) {
          parent.insertBefore(appleWaRow.firstChild, next);
        }
        appleWaRow.remove();
      }
      appleWaRow = null;

      if (!appleBtn.isConnected && buyFoot) {
        buyFoot.insertBefore(appleBtn, buyFoot.firstChild);
      }
      appleBtn.className = originalAppleClass || 'gm-pdp-buy-foot__apple';
      appleBtn.innerHTML = originalAppleHTML;
      appleBtn.style.opacity = '';

      if (els.whatsapp) {
        els.whatsapp.classList.remove('gm-dual-atc__wa');
        els.whatsapp.innerHTML = originalWaHTML.includes('gm-dual-atc__label')
          ? originalWaHTML
          : `<span class="gm-dual-atc__icon" aria-hidden="true">${DUAL_ATC_WHATSAPP_ICON}</span><span class="gm-dual-atc__label">${originalWaHTML}</span>`;
      }
    }

    function setupAppleSquare(position) {
      if (!dockSlot) return;
      appleBtn.className = 'gm-pdp-apple-square';
      appleBtn.innerHTML = `<span class="gm-dual-atc__icon" aria-hidden="true">${APPLE_PAY_ICON}</span>`;
      if (position === 'before') {
        dockSlot.insertBefore(appleBtn, dockSlot.firstChild);
      } else {
        dockSlot.appendChild(appleBtn);
      }
    }

    function setupAppleFullRow() {
      appleBtn.className = 'gm-pdp-buy-foot__whatsapp gm-pdp-buy-foot__whatsapp--apple';
      appleBtn.innerHTML =
        `<span class="gm-dual-atc__icon" aria-hidden="true">${APPLE_PAY_ICON}</span>` +
        `<span class="gm-dual-atc__label">Apple Pay</span>`;
      fold.appendChild(appleBtn);
    }

    function setupApplePair(location) {
      if (!els.whatsapp) return;

      appleWaRow = document.createElement('div');
      appleWaRow.className = 'gm-dual-atc gm-pdp-apple-wa-row';
      appleWaRow.setAttribute('data-gm-apple-wa-row', '');
      appleWaRow.setAttribute('data-gm-dual-toggle', '');
      appleWaRow.setAttribute('data-gm-dual-expanded', 'primary');

      appleBtn.className = 'gm-dual-atc__atc gm-dual-atc__atc-btn gm-dual-atc__apple';
      appleBtn.innerHTML =
        `<span class="gm-dual-atc__icon" aria-hidden="true">${APPLE_PAY_ICON}</span>` +
        `<span class="gm-dual-atc__label">Apple Pay</span>`;

      els.whatsapp.classList.add('gm-dual-atc__wa');
      const waLabel = getDualLabelHTML(els.whatsapp) || originalWaHTML;
      els.whatsapp.innerHTML =
        `<span class="gm-dual-atc__icon" aria-hidden="true">${DUAL_ATC_WHATSAPP_ICON}</span>` +
        `<span class="gm-dual-atc__label">${waLabel}</span>`;

      appleWaRow.appendChild(appleBtn);
      appleWaRow.appendChild(els.whatsapp);
      if (location === 'buyfoot') {
        buyFoot.insertBefore(appleWaRow, buyFoot.firstChild);
        appleWaRow.style.opacity = '1';
      } else {
        fold.appendChild(appleWaRow);
        appleWaRow.style.opacity = '1';
      }
    }

    function teardownDualAtc() {
      if (dockSlot && !wishlistBtn) dockSlot.classList.remove('gm-dual-atc');
      if (atcWrapper && !wishlistBtn) atcWrapper.classList.remove('gm-dual-atc__atc');
      if (atcBtn && !wishlistBtn) {
        atcBtn.classList.remove('gm-dual-atc__atc-btn');
        atcBtn.innerHTML = originalAtcHTML;
      }
      if (els.whatsapp) els.whatsapp.classList.remove('gm-dual-atc__wa');
      ensureWishlistDual();
    }

    function setupDualAtc() {
      if (!dockSlot || !atcBtn || !atcWrapper || !els.whatsapp) return;
      if (wishlistBtn) wishlistBtn.hidden = true;
      dockSlot.classList.add('gm-dual-atc');
      atcWrapper.classList.add('gm-dual-atc__atc');
      atcBtn.classList.add('gm-dual-atc__atc-btn');
      els.whatsapp.classList.add('gm-dual-atc__wa');

      atcBtn.innerHTML =
        `<span class="gm-dual-atc__icon" aria-hidden="true">${DUAL_ATC_CART_ICON}</span>` +
        `<span class="gm-dual-atc__label">${originalAtcHTML}</span>`;
      els.whatsapp.innerHTML =
        `<span class="gm-dual-atc__icon" aria-hidden="true">${DUAL_ATC_WHATSAPP_ICON}</span>` +
        `<span class="gm-dual-atc__label">${originalWaHTML}</span>`;

      dockSlot.appendChild(els.whatsapp);
    }

    function applyVariant(variant) {
      teardownDualAtc();
      resetApple();
      (variant.summaryTail || []).forEach((key) => {
        if (els[key]) summary.appendChild(els[key]);
      });
      (variant.beforeAtc || []).forEach((key) => {
        if (els[key] && atcDockEl) fold.insertBefore(els[key], atcDockEl);
      });
      (variant.foldTail || []).forEach((key) => {
        if (els[key]) fold.appendChild(els[key]);
      });
      (variant.buyFootOrder || []).forEach((key) => {
        if (els[key]) buyFoot.appendChild(els[key]);
      });
      if (els.cashback) {
        els.cashback.classList.toggle('gm-pdp-buy-foot__cashback--pill', !!variant.pill);
      }
      if (els.whatsapp) {
        els.whatsapp.classList.toggle('gm-pdp-buy-foot__whatsapp--green', !!variant.whatsappGreen);
      }
      if (swatchesEl) {
        swatchesEl.classList.toggle('is-natural-width', !!variant.naturalSwatchesWidth);
      }
      fold.classList.toggle('is-compact', !!variant.compactFold);
      if (variant.dualAtc) setupDualAtc();
      if (variant.appleSquare) setupAppleSquare(variant.appleSquare);
      if (variant.appleFullRow) setupAppleFullRow();
      if (variant.appleWhatsappPair) setupApplePair(variant.appleWhatsappPair);
      window.dispatchEvent(new Event('resize'));
    }

    let savedKey = null;
    try {
      savedKey = localStorage.getItem(STORAGE_VARIANT);
    } catch (e) {
      savedKey = null;
    }
    const initial = VARIANTS.find((v) => v.key === savedKey) || DEFAULT_VARIANT;
    if (initial.key !== DEFAULT_VARIANT_KEY) {
      applyVariant(initial);
    }

    const panel = document.createElement('div');
    panel.className = 'gm-layout-lab';
    panel.innerHTML =
      '<div class="gm-layout-lab__head">' +
      '<span>LAYOUT LAB</span>' +
      '<button type="button" class="gm-layout-lab__toggle" aria-label="Recolher">–</button>' +
      '</div>' +
      '<div class="gm-layout-lab__body"></div>' +
      '<button type="button" class="gm-layout-lab__off">desativar</button>';
    document.body.appendChild(panel);

    const body = panel.querySelector('.gm-layout-lab__body');
    const buttons = {};

    VARIANTS.forEach((variant) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gm-layout-lab__variant';
      btn.innerHTML = `<strong>${variant.label}</strong><span>${variant.hint}</span>`;
      btn.addEventListener('click', () => {
        applyVariant(variant);
        Object.values(buttons).forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        try {
          localStorage.setItem(STORAGE_VARIANT, variant.key);
        } catch (e) {
          /* ignore */
        }
      });
      buttons[variant.key] = btn;
      body.appendChild(btn);
    });

    panel.querySelector('.gm-layout-lab__toggle').addEventListener('click', () => {
      panel.classList.toggle('is-collapsed');
    });

    panel.querySelector('.gm-layout-lab__off').addEventListener('click', () => {
      panel.remove();
    });

    buttons[initial.key].classList.add('is-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
